import React, { useState } from 'react';
import { faqs } from '../data/mockData';
import { ChevronDown, Minus, Plus } from 'lucide-react';

const FAQSection = () => {
  const [openId, setOpenId] = useState(1);

  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-16 sm:py-24 px-3 sm:px-4 bg-gray-50 overflow-hidden">
      <div className="max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <p className="text-[#25D366] font-medium mb-3 sm:mb-4 uppercase tracking-wide text-xs sm:text-sm">FAQ</p>
          <h2 className="text-xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Frequently asked <span className="italic">questions</span>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base px-2">
            Get answers to the most commonly asked questions about waatee
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-2 sm:space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className={`bg-white rounded-lg sm:rounded-xl overflow-hidden border transition-all ${
                openId === faq.id ? 'border-[#25D366] shadow-md' : 'border-gray-100 hover:border-gray-200'
              }`}
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full px-4 sm:px-6 py-4 sm:py-5 text-left flex items-center justify-between gap-2"
              >
                <span className={`font-medium text-sm sm:text-base ${
                  openId === faq.id ? 'text-gray-900' : 'text-gray-700'
                }`}>
                  {faq.question}
                </span>
                <div className={`w-7 sm:w-8 h-7 sm:h-8 rounded-full flex items-center justify-center transition-colors flex-shrink-0 ${
                  openId === faq.id ? 'bg-[#25D366] text-white' : 'bg-gray-100 text-gray-500'
                }`}>
                  {openId === faq.id ? (
                    <Minus className="w-3.5 sm:w-4 h-3.5 sm:h-4" />
                  ) : (
                    <Plus className="w-3.5 sm:w-4 h-3.5 sm:h-4" />
                  )}
                </div>
              </button>
              {openId === faq.id && (
                <div className="px-4 sm:px-6 pb-4 sm:pb-5">
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
